export default {
  methods: {
    calcExtraPrice(extra, dates, discount = false) {
      let price = extra.price.amount;
      const count = Math.max(1, dates.reduce((prev, curr) => {
        return prev + curr.count
      }, 0));
      if (['EACH', 'PERSON', 'NONE', 'HOUR', 'DAY'].indexOf(extra.type) !== -1) {
        price *= count;
      }
      if (discount && extra.discount) {
        if (extra.discount.type === 'FIX') {
          price -= extra.discount.amount.amount;
        } else {
          price -= price * extra.discount.amount.amount / 100;
        }
      }
      return price;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/extra-price.mixin.js